import { NoFormControllerError } from "../utils/errors";
import { FormController } from "./useForm";
import { useFormContext } from "./useFormContext";

/**
 * Hook providing access to the controller of the form in context.
 * @throws {NoFormContextError} When no form is in context.
 * @throws {NoFormControllerError} When no form controller is in context.
 * @returns Controller of the form in context.
 */
export function useFormController<T = unknown>(): FormController<T> {
  const formController = useFormContext<T>().controller;
  if (formController == null) {
    throw new NoFormControllerError();
  }
  return formController;
}
